// import React, { useState, useEffect } from "react";
// import "./plumberOrderFormStyle.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const PlumberOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   console.log("use penalty", penalty);
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   // useEffect(() => {
//   //   if (user) {
//   //     setOrderData({
//   //       city: user.city || "",
//   //       address: user.Address || "",
//   //       mobile: user.mobile || "",
//   //     });
//   //   }
//   // }, [user]);

//   useEffect(() => {
//     if (user) {
//       // Added: Check if user status is "Blocked"
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false); // Prevent form from showing
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       toiletInstall: formData.toiletInstall,
//       faucetInstall: formData.faucetInstall,
//       sinkInstall: formData.sinkInstall,
//       dishwasherInstall: formData.dishwasherInstall,
//       leakRepair: formData.leakRepair,
//       faucetRepair: formData.faucetRepair,
//       toiletRepair: formData.toiletRepair,
//       showerRepair: formData.showerRepair,
//       drainCleaning: formData.drainCleaning,
//       pipeCleaning: formData.pipeCleaning,
//       tankCleaning: formData.tankCleaning,
//       issueCheckup: formData.issueCheckup,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 3,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/plumber",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="plumberorder-modal">
//           <div className="plumberorder-overlay" onClick={onClose}></div>
//           <div className="plumberorder-form-container">
//             <div className="plumberorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="plumberorder-form-content">
//               <div className="plumberorder-left">
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="plumberorder-right">
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Toilet Install</label>
//                     <input
//                       type="text"
//                       value={formData.toiletInstall}
//                       readOnly
//                     />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Faucet Install</label>
//                     <input
//                       type="text"
//                       value={formData.faucetInstall}
//                       readOnly
//                     />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Sink Install</label>
//                     <input type="text" value={formData.sinkInstall} readOnly />
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Dishwasher Install</label>
//                     <input
//                       type="text"
//                       value={formData.dishwasherInstall}
//                       readOnly
//                     />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Leak Repair</label>
//                     <input type="text" value={formData.leakRepair} readOnly />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Faucet Repair</label>
//                     <input type="text" value={formData.faucetRepair} readOnly />
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Toilet Repair</label>
//                     <input type="text" value={formData.toiletRepair} readOnly />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Shower Repair</label>
//                     <input type="text" value={formData.showerRepair} readOnly />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Drain Cleaning</label>
//                     <input
//                       type="text"
//                       value={formData.drainCleaning}
//                       readOnly
//                     />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Pipe Cleaning</label>
//                     <input type="text" value={formData.pipeCleaning} readOnly />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Tank Cleaning</label>
//                     <input type="text" value={formData.tankCleaning} readOnly />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Issue Checkup</label>
//                     <input
//                       type="text"
//                       value={formData.issueCheckup ? "Yes" : "No"}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="plumberorder-row">
//                   <div className="plumberorder-col">
//                     <label>Date</label>
//                     <input
//                       type="text"
//                       value={formatDate(formData.date)}
//                       readOnly
//                     />
//                   </div>
//                   <div className="plumberorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 {/* <div className="plumberorder-row">
//                                     <div className="plumberorder-col">
//                                         <label>Total Price</label>
//                                         <input type="text" value={`${formData.price} tk`} readOnly />
//                                         <input type="text" value={`${finalPrice} tk`} readOnly />
//                                     </div>
//                                 </div> */}
//                 <div className="plumberorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="plumberorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="plumberorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="plumberorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="plumberorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="plumberorder-button-container">
//               <button
//                 type="submit"
//                 className="plumberorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button onClick={closeBlockedPopup}>Close</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default PlumberOrderForm;
















// ***** All is checked and okay (19-6-25) ***** //

// import React, { useState, useEffect } from "react";
// import "./plumberOrderFormStyle.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faUser, faCalendarAlt, faTools, faToilet, faFaucet, faSink, faWrench } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const PlumberOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   console.log("use penalty", penalty);
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   useEffect(() => {
//     if (user) {
//       // Check if user status is "Blocked"
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false); // Prevent form from showing
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       toiletInstall: formData.toiletInstall,
//       faucetInstall: formData.faucetInstall,
//       sinkInstall: formData.sinkInstall,
//       dishwasherInstall: formData.dishwasherInstall,
//       leakRepair: formData.leakRepair,
//       faucetRepair: formData.faucetRepair,
//       toiletRepair: formData.toiletRepair,
//       showerRepair: formData.showerRepair,
//       drainCleaning: formData.drainCleaning,
//       pipeCleaning: formData.pipeCleaning,
//       tankCleaning: formData.tankCleaning,
//       issueCheckup: formData.issueCheckup,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 3,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/plumber",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="plumberorder-modal-backdrop">
//           <div className="plumberorder-modal-content">
//             <div className="plumberorder-modal-header">
//               <h2 className="plumberorder-modal-title">Order Details</h2>
//               <button
//                 className="plumberorder-modal-close"
//                 onClick={onClose}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="plumberorder-modal-body">
//               <div className="plumberorder-two-column-grid">
//                 {/* Customer Information Card */}
//                 <div className="plumberorder-modal-card">
//                   <div className="plumberorder-card-body">
//                     <h3 className="plumberorder-card-title">
//                       <FontAwesomeIcon icon={faUser} /> Customer Information
//                     </h3>
//                     <div className="plumberorder-form-grid">
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">Name</label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">Mobile</label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={`0${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">City</label>
//                         <select
//                           name="city"
//                           className="plumberorder-form-control"
//                           value={orderData.city}
//                           onChange={handleChange}
//                         >
//                           <option value="">Select your City</option>
//                           <option value="Dhaka">Dhaka</option>
//                           <option value="Chattogram">Chattogram</option>
//                           <option value="Barishal">Barishal</option>
//                           <option value="Sylhet">Sylhet</option>
//                           <option value="Rajshahi">Rajshahi</option>
//                           <option value="Khulna">Khulna</option>
//                           <option value="Rangpur">Rangpur</option>
//                           <option value="Maymensingh">Maymensingh</option>
//                         </select>
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">Address</label>
//                         <textarea
//                           name="address"
//                           className="plumberorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Booking Details Card */}
//                 <div className="plumberorder-modal-card">
//                   <div className="plumberorder-card-body">
//                     <h3 className="plumberorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} /> Booking Details
//                     </h3>
//                     <div className="plumberorder-form-grid">
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">Date</label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">Time</label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">Base Price</label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">Penalty</label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">Total Price</label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control plumberorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         <div className="plumberorder-form-group">
//                           <label className="plumberorder-form-label">Total Price</label>
//                           <input
//                             type="text"
//                             className="plumberorder-form-control plumberorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Service Details Card */}
//               <div className="plumberorder-modal-card">
//                 <div className="plumberorder-card-body">
//                   <h3 className="plumberorder-card-title">
//                     {/* <FontAwesomeIcon icon={faTools} /> Service Details */}
//                      Service Details
//                   </h3>
//                   <div className="plumberorder-services-section">
//                     {/* Toilet Services */}
//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faToilet} /> Toilet Services
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Toilet Install</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.toiletInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.toiletInstall}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Toilet Repair</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.toiletRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.toiletRepair}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Faucet & Shower Services */}
//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faFaucet} /> Faucet & Shower Services
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Faucet Install</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.faucetInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.faucetInstall}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Faucet Repair</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.faucetRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.faucetRepair}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Shower Repair</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.showerRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.showerRepair}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Sink & Dishwasher Services */}
//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faSink} /> Sink & Dishwasher Services
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Sink Install</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.sinkInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.sinkInstall}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Dishwasher Install</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.dishwasherInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.dishwasherInstall}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Cleaning & Repairs */}
//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faWrench} /> Cleaning & Repairs
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Leak Repair</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.leakRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.leakRepair}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Drain Cleaning</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.drainCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.drainCleaning}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Pipe Cleaning</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.pipeCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.pipeCleaning}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Tank Cleaning</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.tankCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.tankCleaning}{" "}
//                             <span className="plumberorder-service-unit">units</span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">Issue Checkup</label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.issueCheckup ? "boolean-true" : ""
//                             }`}
//                           >
//                             {formData.issueCheckup ? "Yes" : "No"}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="plumberorder-order-actions">
//               <button
//                 className="plumberorder-btn plumberorder-btn-outline"
//                 onClick={onClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="plumberorder-btn plumberorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} /> Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>Order Successfully Placed!</h2>
//             <p>Thank you for choosing HelpNao.</p>
//             <p>Your order is now pending confirmation.</p>
//             <button
//               className="plumberorder-btn plumberorder-btn-primary"
//               onClick={closePopup}
//             >
//               Ok
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button
//               className="plumberorder-btn plumberorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default PlumberOrderForm;




// ***** Upper code check All is okay (19-6-25) ***** //







// ***** Add Translate EN-BN with new updated (19-6-25) ***** //
// import React, { useState, useEffect, useRef } from "react";
// import "./plumberOrderFormStyle.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faUser, faCalendarAlt, faTools, faToilet, faFaucet, faSink, faWrench, faCommentAlt, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import { URL } from "../../../config";

// // const API_BASE = "http://localhost:4001";

// const PlumberOrderForm = ({ user, formData, onClose, onSubmit, previousServitorName, serviceId }) => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   // Locations
//   const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
//   const [areas, setAreas] = useState([]);         // [{Id,name}]
//   const [selectedDivisionId, setSelectedDivisionId] = useState(null);
//   const [selectedAreaId, setSelectedAreaId] = useState(null);

//   // Refs for first invalid field focus
//   const divisionRef = useRef(null);
//   const areaRef = useRef(null);
//   const addressRef = useRef(null);

//   const [orderData, setOrderData] = useState({
//     // city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });

//   const [errors, setErrors] = useState({ city: "", area: "", address: "" });

//   // For coupons
//   const [couponCode, setCouponCode] = useState("");
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [couponError, setCouponError] = useState("");
//   const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   // console.log("use penalty", penalty);
//   const basePrice = Number(formData.price) || 0;
//   // const finalPrice = user.penaltyReserved
//   //   ? basePrice
//   //   : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   const [discountValue, setDiscountValue] = useState(0);
  
//   const finalPrice = (() => {
//     const total = user.penaltyReserved ? basePrice : basePrice + penalty;
//     return Math.max(0, total - discountValue);
//   })();

//   useEffect(() => {
//     if (user) {
//       // Check if user status is "Blocked"
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false); // Prevent form from showing
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);



//   // Load divisions; preselect by user.city
//   useEffect(() => {
//     (async () => {
//       try {
//         const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
//         setDivisions(data || []);
//         if (user?.city) {
//           const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
//           if (match) setSelectedDivisionId(match.Id);
//         }
//       } catch (e) {
//         console.error("Failed to load divisions:", e);
//         setDivisions([]);
//       }
//     })();
//   }, [user?.city]);

//   // Load areas when division changes; preselect by user.area
//   useEffect(() => {
//     (async () => {
//       if (!selectedDivisionId) {
//         setAreas([]);
//         setSelectedAreaId(null);
//         return;
//       }
//       try {
//         const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
//         setAreas(data || []);
//         if (user?.area) {
//           const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
//           setSelectedAreaId(match ? match.Id : null);
//         } else {
//           setSelectedAreaId(null);
//         }
//       } catch (e) {
//         console.error("Failed to load areas:", e);
//         setAreas([]);
//         setSelectedAreaId(null);
//       }
//     })();
//   }, [selectedDivisionId, user?.area]);

//   // Handlers
//   const handleDivisionChange = (e) => {
//     const id = e.target.value ? Number(e.target.value) : null;
//     setSelectedDivisionId(id);
//     setErrors(prev => ({ ...prev, city: "" }));
//   };

//   const handleAreaChange = (e) => {
//     const id = e.target.value ? Number(e.target.value) : null;
//     setSelectedAreaId(id);
//     setErrors(prev => ({ ...prev, area: "" }));
//   };

//   const handleAddressChange = (e) => {
//     const value = e.target.value;
//     setOrderData(prev => ({ ...prev, address: value }));
//     if (value?.trim()) setErrors(prev => ({ ...prev, address: "" }));
//   };

//   // Validation
//   const validate = () => {
//     const errs = { city: "", area: "", address: "" };
//     if (!selectedDivisionId) errs.city = t("Please select your city");
//     if (!selectedAreaId) errs.area = t("Please select your area");
//     if (!orderData.address?.trim()) errs.address = t("Please enter your address");
//     setErrors(errs);
//     return !errs.city && !errs.area && !errs.address;
//   };

//   // const handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setOrderData((prevData) => ({
//   //     ...prevData,
//   //     [name]: value,
//   //   }));
//   // };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) {
//       // focus + scroll to the first invalid
//       if (!selectedDivisionId && divisionRef.current) {
//         divisionRef.current.focus();
//         divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!selectedAreaId && areaRef.current) {
//         areaRef.current.focus();
//         areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!orderData.address?.trim() && addressRef.current) {
//         addressRef.current.focus();
//         addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       }
//       return;
//     }

//     const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
//     const selectedArea = areas.find(a => a.Id === selectedAreaId);

//     const finalOrderData = {
//       userId: user.Id,

//       usercity: selectedDivision?.name || "",
//       userarea: selectedArea?.name || "",       // NEW for API & model
//       useraddress: orderData.address,

//       toiletInstall:     formData.toiletInstall,
//       faucetInstall:     formData.faucetInstall,
//       sinkInstall:       formData.sinkInstall,
//       dishwasherInstall: formData.dishwasherInstall,
//       leakRepair:        formData.leakRepair,
//       faucetRepair:      formData.faucetRepair,
//       toiletRepair:      formData.toiletRepair,
//       showerRepair:      formData.showerRepair,
//       drainCleaning:     formData.drainCleaning,
//       pipeCleaning:      formData.pipeCleaning,
//       tankCleaning:      formData.tankCleaning,

//       geyserSetup:  formData.geyserSetup,
//       geyserRepair: formData.geyserRepair,
//       issueCheckup: formData.issueCheckup,

//       remarks: formData.remarks,

//       // price: formData.price,
//       price: finalPrice,

//       date: formData.date,
//       time: formData.time,
//       status: "pending",

//       // Rebook
//       servitor_id:       formData.useSameServitor ? formData.servitor_id : 0,
//       useSameServitor:   formData.useSameServitor,
//       previousServitorId: formData.servitor_id,

//       serviceId: serviceId || 3,
//     };

//     if (appliedCoupon) {
//       finalOrderData.appliedCoupon = appliedCoupon;
//       finalOrderData.discountValue = discountValue;
//     }

//     try {
//       await axios.post(`${URL}/plumber`, finalOrderData);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };


//   // === Coupon handling ===
//     const handleApplyCoupon = async () => {
//       if (!couponCode.trim()) {
//         setCouponError("Please enter a coupon code.");
//         return;
//       }
//       setIsApplyingCoupon(true);
//       setCouponError("");
//       try {
//         const res = await axios.post(`${URL}/usercoupon/apply`, {
//           userId: user.Id,
//           code: couponCode.trim(),
//         });
//         const { discountValue, code } = res.data;
//         setAppliedCoupon(code);
//         setDiscountValue(discountValue);
//         setCouponError("");
//       } catch (err) {
//         setAppliedCoupon(null);
//         setDiscountValue(0);
//         setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
//       } finally {
//         setIsApplyingCoupon(false);
//       }
//     };
  
//     const handleRemoveCoupon = async () => {
//       // try {
//       //   await axios.post(`${URL}/usercoupon/remove`, {
//       //     userId: user.Id,
//       //     code: appliedCoupon,
//       //   });
//       // } catch (err) {
//       //   console.warn("Coupon removal failed (non-blocking):", err);
//       // }
//       setAppliedCoupon(null);
//       setDiscountValue(0);
//       setCouponCode("");
//       setCouponError("");
//     };
  

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//     onSubmit();
//     navigate("/profile/orderhistory");
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="plumberorder-modal-backdrop">
//           <div className="plumberorder-modal-content">
//             <div className="plumberorder-modal-header">
//               <h2 className="plumberorder-modal-title">
//                 {/* Order Details */}
//                 {t("plumberorderform.order_form.modal.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <button className="plumberorder-modal-close" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="plumberorder-modal-body">
//               <div className="plumberorder-two-column-grid">
//                 <div className="plumberorder-modal-card">
//                   <div className="plumberorder-card-body">
//                     <h3 className="plumberorder-card-title">
//                       <FontAwesomeIcon icon={faUser} />
//                       {/* Customer Information */}
//                       {t(
//                         "plumberorderform.order_form.customer_information.title"
//                       )}{" "}
//                       {/* CHANGED: Added translation */}
//                     </h3>
//                     <div className="plumberorder-form-grid">
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* Name */}
//                           {t(
//                             "plumberorderform.order_form.customer_information.labels.name"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* Mobile */}
//                           {t(
//                             "plumberorderform.order_form.customer_information.labels.mobile"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={`${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* City */}
//                           {t(
//                             "plumberorderform.order_form.customer_information.labels.city"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <select
//                           className={`plumberorder-form-control ${errors.city ? "pl-error" : ""}`}
//                           value={selectedDivisionId || ""}
//                           onChange={handleDivisionChange}
//                           onBlur={validate}
//                           ref={divisionRef}
//                         >
//                           <option value="">{t("plumberorderform.order_form.customer_information.labels.city_placeholder")}</option>
//                           {divisions.map(d => (
//                             <option key={d.Id} value={d.Id}>{d.name}</option>
//                           ))}
//                         </select>
//                         {errors.city && <small className="pl-error-text">{errors.city}</small>}
//                       </div>

//                       {/* Area */}
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {t("homecleanorderform.order_form.customer_information.labels.area", "Area")}
//                         </label>
//                         <select
//                           className={`plumberorder-form-control ${errors.area ? "pl-error" : ""}`}
//                           value={selectedAreaId || ""}
//                           onChange={handleAreaChange}
//                           onBlur={validate}
//                           disabled={!selectedDivisionId}
//                           ref={areaRef}
//                         >
//                           <option value="">
//                             {!selectedDivisionId ? t("Select City first") : t("Select Area")}
//                           </option>
//                           {areas.map(a => (
//                             <option key={a.Id} value={a.Id}>{a.name}</option>
//                           ))}
//                         </select>
//                         {errors.area && <small className="pl-error-text">{errors.area}</small>}
//                       </div>


//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* Address */}
//                           {t(
//                             "plumberorderform.order_form.customer_information.labels.address"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <textarea
//                           className={`plumberorder-form-control ${errors.address ? "pl-error" : ""}`}
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleAddressChange}
//                           onBlur={validate}
//                           ref={addressRef}
//                         />
//                         {errors.address && <small className="pl-error-text">{errors.address}</small>}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="plumberorder-modal-card">
//                   <div className="plumberorder-card-body">
//                     <h3 className="plumberorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} />
//                       {/* Booking Details */}
//                       {t(
//                         "plumberorderform.order_form.booking_details.title"
//                       )}{" "}
//                       {/* CHANGED: Added translation */}
//                     </h3>
//                     <div className="plumberorder-form-grid">
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* Date */}
//                           {t(
//                             "plumberorderform.order_form.booking_details.labels.date"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="plumberorder-form-group">
//                         <label className="plumberorder-form-label">
//                           {/* Time */}
//                           {t(
//                             "plumberorderform.order_form.booking_details.labels.time"
//                           )}{" "}
//                           {/* CHANGED: Added translation */}
//                         </label>
//                         <input
//                           type="text"
//                           className="plumberorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">
//                               {/* Base Price */}
//                               {t(
//                                 "plumberorderform.order_form.booking_details.labels.base_price"
//                               )}{" "}
//                               {/* CHANGED: Added translation */}
//                             </label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">
//                               {/* Penalty */}
//                               {t(
//                                 "plumberorderform.order_form.booking_details.labels.penalty"
//                               )}{" "}
//                               {/* CHANGED: Added translation */}
//                             </label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control plumberorder-penalty-field"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="plumberorder-form-group">
//                             <label className="plumberorder-form-label">
//                               {/* Total Price */}
//                               {t(
//                                 "plumberorderform.order_form.booking_details.labels.total_price"
//                               )}{" "}
//                               {/* CHANGED: Added translation */}
//                             </label>
//                             <input
//                               type="text"
//                               className="plumberorder-form-control plumberorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         // <div className="plumberorder-form-group">
//                         //   <label className="plumberorder-form-label">
//                         //     {t(
//                         //       "plumberorderform.order_form.booking_details.labels.total_price"
//                         //     )}{" "}
//                         //   </label>
//                         //   <input
//                         //     type="text"
//                         //     className="plumberorder-form-control plumberorder-total-price"
//                         //     value={`${finalPrice} tk`}
//                         //     readOnly
//                         //   />
//                         // </div>

//                         // New design for dicount
//                         <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.total_price")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-price-discounted">
//                             <div className="electricianorder-original-price">
//                               {user.penaltyReserved
//                                 ? `${basePrice} tk`
//                                 : `${basePrice + penalty} tk`}
//                             </div>

//                             <div className="electricianorder-final-price">
//                               <span className="discounted-price">{finalPrice} tk</span>
//                               <small className="discount-label">({discountValue} tk off)</small>
//                             </div>
//                           </div>
//                         ) : (
//                           <input
//                             type="text"
//                             className="electricianorder-form-control electricianorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         )}
//                       </div>
//                       )}

//                       {/* Coupon Code */}
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-coupon-applied">
//                             {/* <p>
//                               ✅ Applied: <strong>{appliedCoupon}</strong>
//                             </p> */}
//                              <p>
//                                 ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
//                                 <strong>{appliedCoupon}</strong>
//                               </p>
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-outline"
//                               className="electricianorder-btn-removecoupon"
//                               onClick={handleRemoveCoupon}
//                             >
//                               {/* Remove */}
//                               {t("electricianorderform.coupon.remove", "Remove")}
//                             </button>
//                           </div>
//                         ) : (
//                           <div className="electricianorder-coupon-input-row">
//                             <input
//                               type="text"
//                               value={couponCode}
//                               onChange={(e) => setCouponCode(e.target.value)}
//                               placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
//                               className="electricianorder-form-control"
//                               disabled={isApplyingCoupon}
//                             />
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-primary"
//                               className="electricianorder-btn-applycoupon"
//                               onClick={handleApplyCoupon}
//                               disabled={isApplyingCoupon}
//                             >
//                               {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
//                               {isApplyingCoupon
//                                 ? t("electricianorderform.coupon.applying", "Applying...")
//                                 : t("electricianorderform.coupon.apply", "Apply")}
//                             </button>
//                           </div>
//                         )}

//                         {/* {couponError && <div className="field-error">{couponError}</div>} */}

//                         {couponError && (
//                           <div className="field-error">
//                             {t("electricianorderform.coupon.invalid", couponError)}
//                           </div>
//                         )}

//                       </div>
                      
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="plumberorder-modal-card">
//                 <div className="plumberorder-card-body">
//                   <h3 className="plumberorder-card-title">
//                     {/* <FontAwesomeIcon icon={faTools} /> Service Details */}
//                     {t(
//                       "plumberorderform.order_form.service_details.title"
//                     )}{" "}
//                     {/* CHANGED: Added translation */}
//                   </h3>
//                   <div className="plumberorder-services-section">
//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faToilet} />
//                         {/* Toilet Services */}
//                         {t(
//                           "plumberorderform.order_form.service_details.categories.toilet_services.title"
//                         )}{" "}
//                         {/* CHANGED: Added translation */}
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Toilet Install */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.toilet_services.labels.toilet_install"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.toiletInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.toiletInstall}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.toiletInstall === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Toilet Repair */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.toilet_services.labels.toilet_repair"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.toiletRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.toiletRepair}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.toiletRepair === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faFaucet} />
//                         {/* Faucet & Shower Services */}
//                         {t(
//                           "plumberorderform.order_form.service_details.categories.faucet_shower_services.title"
//                         )}{" "}
//                         {/* CHANGED: Added translation */}
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Faucet Install */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.faucet_shower_services.labels.faucet_install"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.faucetInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.faucetInstall}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.faucetInstall === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Faucet Repair */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.faucet_shower_services.labels.faucet_repair"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.faucetRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.faucetRepair}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.faucetRepair === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Shower Repair */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.faucet_shower_services.labels.shower_repair"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.showerRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.showerRepair}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.showerRepair === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faSink} />
//                         {/* Sink & Dishwasher Services */}
//                         {t(
//                           "plumberorderform.order_form.service_details.categories.sink_dishwasher_services.title"
//                         )}{" "}
//                         {/* CHANGED: Added translation */}
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Sink Install */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.sink_dishwasher_services.labels.sink_install"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.sinkInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.sinkInstall}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.sinkInstall === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Dishwasher Install */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.sink_dishwasher_services.labels.dishwasher_install"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.dishwasherInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.dishwasherInstall}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.dishwasherInstall === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="plumberorder-service-category">
//                       <h4 className="plumberorder-category-header">
//                         <FontAwesomeIcon icon={faWrench} />
//                         {/* Cleaning & Repairs */}
//                         {t(
//                           "plumberorderform.order_form.service_details.categories.cleaning_repairs.title"
//                         )}{" "}
//                         {/* CHANGED: Added translation */}
//                       </h4>
//                       <div className="plumberorder-services-grid">
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Leak Repair */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.leak_repair"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.leakRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.leakRepair}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.leakRepair === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Drain Cleaning */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.drain_cleaning"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.drainCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.drainCleaning}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.drainCleaning === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Pipe Cleaning */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.pipe_cleaning"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.pipeCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.pipeCleaning}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.pipeCleaning === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Tank Cleaning */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.tank_cleaning"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.tankCleaning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.tankCleaning}{" "}
//                             <span className="plumberorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.tankCleaning === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Added translation for unit/units */}
//                             </span>
//                           </div>
//                         </div>


//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Geyser Install */}
//                             {t("plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.geyser_setup")}
//                           </label>
//                           <div className={`plumberorder-service-value ${formData.geyserSetup > 0 ? "has-value" : ""}`}>
//                             {formData.geyserSetup}{" "}
//                             <span className="plumberorder-service-unit">
//                               {t(
//                                 formData.geyserSetup === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Geyser Repair */}
//                             {t("plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.geyser_repair")}
//                           </label>
//                           <div className={`plumberorder-service-value ${formData.geyserRepair > 0 ? "has-value" : ""}`}>
//                             {formData.geyserRepair}{" "}
//                             <span className="plumberorder-service-unit">
//                               {t(
//                                 formData.geyserRepair === 1
//                                   ? "plumberorderform.order_form.service_details.unit"
//                                   : "plumberorderform.order_form.service_details.units"
//                               )}
//                             </span>
//                           </div>
//                         </div>

//                         <div className="plumberorder-service-item">
//                           <label className="plumberorder-form-label">
//                             {/* Issue Checkup */}
//                             {t(
//                               "plumberorderform.order_form.service_details.categories.cleaning_repairs.labels.issue_checkup"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </label>
//                           <div
//                             className={`plumberorder-service-value ${
//                               formData.issueCheckup ? "boolean-true" : ""
//                             }`}
//                           >
//                             {/* {formData.issueCheckup ? "Yes" : "No"} */}
//                             {t(
//                               `plumberorderform.order_form.service_details.categories.cleaning_repairs.issue_checkup_values.${
//                                 formData.issueCheckup ? "yes" : "no"
//                               }`
//                             )}{" "}
//                             {/* CHANGED: Added translation for Yes/No */}
//                           </div>
//                         </div>

//                         {formData.useSameServitor && previousServitorName && (
//                           <div className="plumberorder-service-item plumberorder-rebook-item">
//                             <label className="plumberorder-form-label plumberorder-label-content">
//                               <FontAwesomeIcon icon={faCheckCircle} className="plumberorder-rebook-icon" />
//                               {t("plumberorderform.order_form.rebook.label")}
//                             </label>
//                             <div className="plumberorder-service-value plumberorder-rebook-value">
//                               <strong>{previousServitorName}</strong>
//                             </div>
//                           </div>
//                         )}


//                         {formData.remarks && (
//                           <div className="plumberorder-service-item plumberorder-remarks-item">
//                             <label className="plumberorder-form-label">
//                               <FontAwesomeIcon
//                                 icon={faCommentAlt}
//                                 className="plumberorder-remarks-icon"
//                               />
//                               {t(
//                                 "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
//                               )}
//                             </label>
//                             <div className="plumberorder-service-value has-value plumberorder-remarks-value">
//                               {formData.remarks}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="plumberorder-order-actions">
//               <button
//                 className="plumberorder-btn plumberorder-btn-outline"
//                 onClick={onClose}
//               >
//                 {/* Cancel */}
//                 {t("plumberorderform.order_form.actions.cancel")}{" "}
//                 {/* CHANGED: Added translation */}
//               </button>
//               <button
//                 className="plumberorder-btn plumberorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} />
//                 {/* Place Order */}
//                 {t("plumberorderform.order_form.actions.place_order")}{" "}
//                 {/* CHANGED: Added translation */}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>
//               {/* Order Successfully Placed! */}
//               {t("plumberorderform.order_form.success_popup.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h2>
//             <p>
//               {/* Thank you for choosing HelpNao. */}
//               {t("plumberorderform.order_form.success_popup.message1")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//             <p>
//               {/* Your order is now pending confirmation. */}
//               {t("plumberorderform.order_form.success_popup.message2")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//             <button
//               className="plumberorder-btn plumberorder-btn-primary"
//               onClick={closePopup}
//             >
//               {/* Ok */}
//               {t("plumberorderform.order_form.success_popup.button")}{" "}
//               {/* CHANGED: Added translation */}
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="plumberorder-success-popup">
//           <div className="plumberorder-success-popup-content">
//             <h2>
//               {/* Account Blocked */}
//               {t("plumberorderform.order_form.blocked_popup.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h2>
//             <p>
//               {/* Your account is blocked due to excessive cancellations. */}
//               {t("plumberorderform.order_form.blocked_popup.message1")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//             <p>
//               {/* Please contact our support team for assistance. */}
//               {t("plumberorderform.order_form.blocked_popup.message2")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//             <button
//               className="plumberorder-btn plumberorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               {/* Close */}
//               {t("plumberorderform.order_form.blocked_popup.button")}{" "}
//               {/* CHANGED: Added translation */}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
//   };

// export default PlumberOrderForm;





// ***** Update with new features (23-Oct-2025) ***** //
import React, { useState, useEffect, useRef } from "react";
import "./plumberOrderFormStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUser, faCalendarAlt, faTools, faToilet, faSink, faBath, faFire, faCommentAlt, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { URL } from "../../../config";

// const API_BASE = "http://localhost:4001";

const PlumberOrderForm = ({ user, formData, onClose, onSubmit, previousServitorName, serviceId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Locations
  const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
  const [areas, setAreas] = useState([]);         // [{Id,name}]
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  // Refs for first invalid field focus
  const divisionRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const [orderData, setOrderData] = useState({
    // city: user?.city || "",
    address: user?.Address || "",
    mobile: user?.mobile || "",
  });

  const [errors, setErrors] = useState({ city: "", area: "", address: "" });

  // For coupons
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);

  // Compute penalty and final price (base price + penalty)
  // const penalty = user && user.penalty ? Number(user.penalty) : 0;

  // console.log("use penalty", penalty);
  const basePrice = Number(formData.price) || 0;
  // const finalPrice = user.penaltyReserved
  //   ? basePrice
  //   : basePrice + (user.penalty ? Number(user.penalty) : 0);

  const [discountValue, setDiscountValue] = useState(0);
  
  // const finalPrice = (() => {
  //   const total = user.penaltyReserved ? basePrice : basePrice + penalty;
  //   return Math.max(0, total - discountValue);
  // })();

  const finalPrice = Math.max(0, basePrice - discountValue);

  useEffect(() => {
    if (user) {
      // Check if user status is "Blocked"
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false); // Prevent form from showing
      } else {
        setOrderData({
          city: user.city || "",
          address: user.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user]);

  // Disable background scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);



  // Load divisions; preselect by user.city
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
        setDivisions(data || []);
        if (user?.city) {
          const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
          if (match) setSelectedDivisionId(match.Id);
        }
      } catch (e) {
        console.error("Failed to load divisions:", e);
        setDivisions([]);
      }
    })();
  }, [user?.city]);

  // Load areas when division changes; preselect by user.area
  useEffect(() => {
    (async () => {
      if (!selectedDivisionId) {
        setAreas([]);
        setSelectedAreaId(null);
        return;
      }
      try {
        const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
        setAreas(data || []);
        if (user?.area) {
          const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
          setSelectedAreaId(match ? match.Id : null);
        } else {
          setSelectedAreaId(null);
        }
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId(null);
      }
    })();
  }, [selectedDivisionId, user?.area]);

  // Handlers
  const handleDivisionChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedDivisionId(id);
    setErrors(prev => ({ ...prev, city: "" }));
  };

  const handleAreaChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedAreaId(id);
    setErrors(prev => ({ ...prev, area: "" }));
  };

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setOrderData(prev => ({ ...prev, address: value }));
    if (value?.trim()) setErrors(prev => ({ ...prev, address: "" }));
  };

  // Validation
  const validate = () => {
    const errs = { city: "", area: "", address: "" };
    if (!selectedDivisionId) errs.city = t("Please select your city");
    if (!selectedAreaId) errs.area = t("Please select your area");
    if (!orderData.address?.trim()) errs.address = t("Please enter your address");
    setErrors(errs);
    return !errs.city && !errs.area && !errs.address;
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validate()) {
      // focus + scroll to the first invalid
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
    const selectedArea = areas.find(a => a.Id === selectedAreaId);

    const finalOrderData = {
      userId: user.Id,

      usercity: selectedDivision?.name || "",
      userarea: selectedArea?.name || "",       // NEW for API & model
      useraddress: orderData.address,

      angleValveSetup: formData.angleValveSetup,
      basinTapSetup: formData.basinTapSetup,
      magicPipeSetup: formData.magicPipeSetup,
      basinWastePopUpSetup: formData.basinWastePopUpSetup,
      newBasinSetupExistingLines: formData.newBasinSetupExistingLines,

      bathroomTapBibCockSetup: formData.bathroomTapBibCockSetup,
      tissueHolderSetup: formData.tissueHolderSetup,
      handShowerSetup: formData.handShowerSetup,
      soapDishSetup: formData.soapDishSetup,
      bathroomShelfSetup: formData.bathroomShelfSetup,
      mirrorSetup: formData.mirrorSetup,
      towelHangerSetup: formData.towelHangerSetup,
      showerHeadSetup: formData.showerHeadSetup,
      concealedStopcockSetup: formData.concealedStopcockSetup,
      floorDrainNetSetup: formData.floorDrainNetSetup,

      fillValveReplacement: formData.fillValveReplacement,
      toiletSeatCoverReplacement: formData.toiletSeatCoverReplacement,
      toiletSeatCompleteInstallation: formData.toiletSeatCompleteInstallation,
      highCommodeInstallationExistingLines: formData.highCommodeInstallationExistingLines,
      blockageClearingHighCommode: formData.blockageClearingHighCommode,
      blockageClearingLowCommode: formData.blockageClearingLowCommode,

      bathroomDrainLineCleaning: formData.bathroomDrainLineCleaning,

      geyserInstallation: formData.geyserInstallation,

      kitchenSinkSetupExistingLines: formData.kitchenSinkSetupExistingLines,
      sinkBlockageCleaning: formData.sinkBlockageCleaning,
      washingMachinePointSetup: formData.washingMachinePointSetup,
      issueCheckup: formData.issueCheckup,

      remarks: formData.remarks,

      // price: formData.price,
      price: finalPrice,

      date: formData.date,
      time: formData.time,
      status: "pending",

      // Rebook
      servitor_id:       formData.useSameServitor ? formData.servitor_id : 0,
      useSameServitor:   formData.useSameServitor,
      previousServitorId: formData.servitor_id,

      serviceId: serviceId || 3,
    };

    if (appliedCoupon) {
      finalOrderData.appliedCoupon = appliedCoupon;
      finalOrderData.discountValue = discountValue;
    }

    try {
      setIsSubmitting(true);

      await axios.post(`${URL}/plumber`, finalOrderData);
      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  // === Coupon handling ===
    const handleApplyCoupon = async () => {
      if (!couponCode.trim()) {
        setCouponError("Please enter a coupon code.");
        return;
      }
      setIsApplyingCoupon(true);
      setCouponError("");
      try {
        const res = await axios.post(`${URL}/usercoupon/apply`, {
          userId: user.Id,
          code: couponCode.trim(),
        });
        const { discountValue, code } = res.data;
        setAppliedCoupon(code);
        setDiscountValue(discountValue);
        setCouponError("");
      } catch (err) {
        setAppliedCoupon(null);
        setDiscountValue(0);
        setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
      } finally {
        setIsApplyingCoupon(false);
      }
    };
  
    const handleRemoveCoupon = async () => {
      // try {
      //   await axios.post(`${URL}/usercoupon/remove`, {
      //     userId: user.Id,
      //     code: appliedCoupon,
      //   });
      // } catch (err) {
      //   console.warn("Coupon removal failed (non-blocking):", err);
      // }
      setAppliedCoupon(null);
      setDiscountValue(0);
      setCouponCode("");
      setCouponError("");
    };
  

  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    onSubmit();
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };

  return (
    <>
      {showForm && (
        <div className="plumberorder-modal-backdrop">
          <div className="plumberorder-modal-content">
            <div className="plumberorder-modal-header">
              <h2 className="plumberorder-modal-title">
                {/* Order Details */}
                {t("plumberorderform.order_form.modal.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <button className="plumberorder-modal-close" onClick={onClose}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="plumberorder-modal-body">
              <div className="plumberorder-two-column-grid">
                <div className="plumberorder-modal-card">
                  <div className="plumberorder-card-body">
                    <h3 className="plumberorder-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {/* Customer Information */}
                      {t(
                        "plumberorderform.order_form.customer_information.title"
                      )}{" "}
                      {/* CHANGED: Added translation */}
                    </h3>
                    <div className="plumberorder-form-grid">
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* Name */}
                          {t(
                            "plumberorderform.order_form.customer_information.labels.name"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="plumberorder-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* Mobile */}
                          {t(
                            "plumberorderform.order_form.customer_information.labels.mobile"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="plumberorder-form-control"
                          value={`${orderData.mobile}`}
                          readOnly
                        />
                      </div>
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* City */}
                          {t(
                            "plumberorderform.order_form.customer_information.labels.city"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <select
                          className={`plumberorder-form-control ${errors.city ? "pl-error" : ""}`}
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          ref={divisionRef}
                        >
                          <option value="">{t("plumberorderform.order_form.customer_information.labels.city_placeholder")}</option>
                          {divisions.map(d => (
                            <option key={d.Id} value={d.Id}>{d.name}</option>
                          ))}
                        </select>
                        {errors.city && <small className="pl-error-text">{errors.city}</small>}
                      </div>

                      {/* Area */}
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {t("homecleanorderform.order_form.customer_information.labels.area", "Area")}
                        </label>
                        <select
                          className={`plumberorder-form-control ${errors.area ? "pl-error" : ""}`}
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          disabled={!selectedDivisionId}
                          ref={areaRef}
                        >
                          <option value="">
                            {!selectedDivisionId ? t("Select City first") : t("Select Area")}
                          </option>
                          {areas.map(a => (
                            <option key={a.Id} value={a.Id}>{a.name}</option>
                          ))}
                        </select>
                        {errors.area && <small className="pl-error-text">{errors.area}</small>}
                      </div>


                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* Address */}
                          {t(
                            "plumberorderform.order_form.customer_information.labels.address"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <textarea
                          className={`plumberorder-form-control ${errors.address ? "pl-error" : ""}`}
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          ref={addressRef}
                        />
                        {errors.address && <small className="pl-error-text">{errors.address}</small>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="plumberorder-modal-card">
                  <div className="plumberorder-card-body">
                    <h3 className="plumberorder-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {/* Booking Details */}
                      {t(
                        "plumberorderform.order_form.booking_details.title"
                      )}{" "}
                      {/* CHANGED: Added translation */}
                    </h3>
                    <div className="plumberorder-form-grid">
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* Date */}
                          {t(
                            "plumberorderform.order_form.booking_details.labels.date"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="plumberorder-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>
                      <div className="plumberorder-form-group">
                        <label className="plumberorder-form-label">
                          {/* Time */}
                          {t(
                            "plumberorderform.order_form.booking_details.labels.time"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="plumberorder-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>
                      {/* {!user.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="plumberorder-form-group">
                            <label className="plumberorder-form-label">
                              {t(
                                "plumberorderform.order_form.booking_details.labels.base_price"
                              )}{" "}
                            </label>
                            <input
                              type="text"
                              className="plumberorder-form-control"
                              value={`${basePrice} tk`}
                              readOnly
                            />
                          </div>
                          <div className="plumberorder-form-group">
                            <label className="plumberorder-form-label">
                              {t(
                                "plumberorderform.order_form.booking_details.labels.penalty"
                              )}{" "}
                            </label>
                            <input
                              type="text"
                              className="plumberorder-form-control plumberorder-penalty-field"
                              value={`${penalty} tk`}
                              readOnly
                            />
                          </div>
                          <div className="plumberorder-form-group">
                            <label className="plumberorder-form-label">
                              {t(
                                "plumberorderform.order_form.booking_details.labels.total_price"
                              )}{" "}
                            </label>
                            <input
                              type="text"
                              className="plumberorder-form-control plumberorder-total-price"
                              value={`${finalPrice} tk`}
                              readOnly
                            />
                          </div>
                        </>
                      ) : (
                        // New design for dicount
                        <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {user.penaltyReserved
                                ? `${basePrice} tk`
                                : `${basePrice + penalty} tk`}
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>
                      )} */}


                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {basePrice} tk
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>





                      {/* Coupon Code */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-coupon-applied">
                            {/* <p>
                              ✅ Applied: <strong>{appliedCoupon}</strong>
                            </p> */}
                             <p>
                                ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
                                <strong>{appliedCoupon}</strong>
                              </p>
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-outline"
                              className="electricianorder-btn-removecoupon"
                              onClick={handleRemoveCoupon}
                            >
                              {/* Remove */}
                              {t("electricianorderform.coupon.remove", "Remove")}
                            </button>
                          </div>
                        ) : (
                          <div className="electricianorder-coupon-input-row">
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
                              className="electricianorder-form-control"
                              disabled={isApplyingCoupon}
                            />
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-primary"
                              className="electricianorder-btn-applycoupon"
                              onClick={handleApplyCoupon}
                              disabled={isApplyingCoupon}
                            >
                              {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
                              {isApplyingCoupon
                                ? t("electricianorderform.coupon.applying", "Applying...")
                                : t("electricianorderform.coupon.apply", "Apply")}
                            </button>
                          </div>
                        )}

                        {/* {couponError && <div className="field-error">{couponError}</div>} */}

                        {couponError && (
                          <div className="field-error">
                            {t("electricianorderform.coupon.invalid", couponError)}
                          </div>
                        )}

                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

              <div className="plumberorder-modal-card">
                <div className="plumberorder-card-body">
                  <h3 className="plumberorder-card-title">
                    {/* <FontAwesomeIcon icon={faTools} /> Service Details */}
                    {t(
                      "plumberorderform.order_form.service_details.title"
                    )}{" "}
                    {/* CHANGED: Added translation */}
                  </h3>
                  <div className="plumberorder-services-section">
                                      <div className="plumberorder-service-category">
                                        <h4 className="plumberorder-category-header">
                                          <FontAwesomeIcon icon={faSink} />
                                          {t(
                                            "plumberorderform.order_form.service_details.categories.bathroom_fixtures.title"
                                          )}
                                        </h4>
                                        <div className="plumberorder-services-grid">

                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_fixtures.labels.newBasinSetupExistingLines"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.newBasinSetupExistingLines > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.newBasinSetupExistingLines}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.newBasinSetupExistingLines === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          
                                          
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_fixtures.labels.basinTapSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.basinTapSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.basinTapSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.basinTapSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_fixtures.labels.magicPipeSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.magicPipeSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.magicPipeSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.magicPipeSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_fixtures.labels.basinWastePopUpSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.basinWastePopUpSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.basinWastePopUpSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.basinWastePopUpSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>


                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_fixtures.labels.angleValveSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.angleValveSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.angleValveSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.angleValveSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          
                                        </div>
                                      </div>
                  
                                      <div className="plumberorder-service-category">
                                        <h4 className="plumberorder-category-header">
                                          <FontAwesomeIcon icon={faBath} />
                                          {t(
                                            "plumberorderform.order_form.service_details.categories.bathroom_accessories.title"
                                          )}
                                        </h4>
                                        <div className="plumberorder-services-grid">
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.bathroomTapBibCockSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.bathroomTapBibCockSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.bathroomTapBibCockSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.bathroomTapBibCockSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.tissueHolderSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.tissueHolderSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.tissueHolderSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.tissueHolderSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.fillValveReplacement"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.fillValveReplacement > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.fillValveReplacement}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.fillValveReplacement === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.handShowerSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.handShowerSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.handShowerSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.handShowerSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.soapDishSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.soapDishSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.soapDishSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.soapDishSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.bathroomShelfSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.bathroomShelfSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.bathroomShelfSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.bathroomShelfSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.mirrorSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.mirrorSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.mirrorSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.mirrorSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.towelHangerSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.towelHangerSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.towelHangerSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.towelHangerSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.showerHeadSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.showerHeadSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.showerHeadSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.showerHeadSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.concealedStopcockSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.concealedStopcockSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.concealedStopcockSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.concealedStopcockSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.bathroom_accessories.labels.floorDrainNetSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.floorDrainNetSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.floorDrainNetSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.floorDrainNetSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  
                                      <div className="plumberorder-service-category">
                                        <h4 className="plumberorder-category-header">
                                          <FontAwesomeIcon icon={faToilet} />
                                          {t(
                                            "plumberorderform.order_form.service_details.categories.toilet_commode.title"
                                          )}
                                        </h4>
                                        <div className="plumberorder-services-grid">
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.toiletSeatCoverReplacement"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.toiletSeatCoverReplacement > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.toiletSeatCoverReplacement}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.toiletSeatCoverReplacement === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.toiletSeatCompleteInstallation"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.toiletSeatCompleteInstallation > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.toiletSeatCompleteInstallation}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.toiletSeatCompleteInstallation === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.highCommodeInstallationExistingLines"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.highCommodeInstallationExistingLines > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.highCommodeInstallationExistingLines}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.highCommodeInstallationExistingLines === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.blockageClearingHighCommode"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.blockageClearingHighCommode > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.blockageClearingHighCommode}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.blockageClearingHighCommode === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.blockageClearingLowCommode"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.blockageClearingLowCommode > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.blockageClearingLowCommode}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.blockageClearingLowCommode === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.toilet_commode.labels.bathroomDrainLineCleaning"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.bathroomDrainLineCleaning > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.bathroomDrainLineCleaning}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.bathroomDrainLineCleaning === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  
                                      <div className="plumberorder-service-category">
                                        <h4 className="plumberorder-category-header">
                                          <FontAwesomeIcon icon={faFire} />
                                          {t(
                                            "plumberorderform.order_form.service_details.categories.geyser_kitchen.title"
                                          )}
                                        </h4>
                                        <div className="plumberorder-services-grid">
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.geyser_kitchen.labels.geyserInstallation"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.geyserInstallation > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.geyserInstallation}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.geyserInstallation === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.geyser_kitchen.labels.kitchenSinkSetupExistingLines"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.kitchenSinkSetupExistingLines > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.kitchenSinkSetupExistingLines}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.kitchenSinkSetupExistingLines === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.geyser_kitchen.labels.sinkBlockageCleaning"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.sinkBlockageCleaning > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.sinkBlockageCleaning}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.sinkBlockageCleaning === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.geyser_kitchen.labels.washingMachinePointSetup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.washingMachinePointSetup > 0 ? "has-value" : ""
                                              }`}
                                            >
                                              {formData.washingMachinePointSetup}{" "}
                                              <span className="plumberorder-service-unit">
                                                {t(
                                                  formData.washingMachinePointSetup === 1
                                                    ? "plumberorderform.order_form.service_details.unit"
                                                    : "plumberorderform.order_form.service_details.units"
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                  
                                      <div className="plumberorder-service-category">
                                        <h4 className="plumberorder-category-header">
                                          {t(
                                            "plumberorderform.order_form.service_details.categories.issue_checkup.title"
                                          )}
                                        </h4>
                                        <div className="plumberorder-services-grid">
                                          <div className="plumberorder-service-item">
                                            <label className="plumberorder-form-label">
                                              {t(
                                                "plumberorderform.order_form.service_details.categories.issue_checkup.labels.issue_checkup"
                                              )}
                                            </label>
                                            <div
                                              className={`plumberorder-service-value ${
                                                formData.issueCheckup ? "boolean-true" : ""
                                              }`}
                                            >
                                              {t(
                                                `plumberorderform.order_form.service_details.categories.issue_checkup.values.${
                                                  formData.issueCheckup ? "yes" : "no"
                                                }`
                                              )}
                                            </div>
                                          </div>
                                        

                        {formData.useSameServitor && previousServitorName && (
                          <div className="plumberorder-service-item plumberorder-rebook-item">
                            <label className="plumberorder-form-label plumberorder-label-content">
                              <FontAwesomeIcon icon={faCheckCircle} className="plumberorder-rebook-icon" />
                              {t("plumberorderform.order_form.rebook.label")}
                            </label>
                            <div className="plumberorder-service-value plumberorder-rebook-value">
                              <strong>{previousServitorName}</strong>
                            </div>
                          </div>
                        )}


                        {formData.remarks && (
                          <div className="plumberorder-service-item plumberorder-remarks-item">
                            <label className="plumberorder-form-label">
                              <FontAwesomeIcon
                                icon={faCommentAlt}
                                className="plumberorder-remarks-icon"
                              />
                              {t(
                                "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
                              )}
                            </label>
                            <div className="plumberorder-service-value has-value plumberorder-remarks-value">
                              {formData.remarks}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="plumberorder-order-actions">
              <button
                className="plumberorder-btn plumberorder-btn-outline"
                onClick={onClose}
              >
                {/* Cancel */}
                {t("plumberorderform.order_form.actions.cancel")}{" "}
                {/* CHANGED: Added translation */}
              </button>
              <button
                className="plumberorder-btn plumberorder-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faTools} />
                {/* Place Order */}
                {/* {t("plumberorderform.order_form.actions.place_order")}{" "} */}
                {isSubmitting
                  ? t("plumberorderform.order_form.actions.placing", "Placing...")
                  : t("plumberorderform.order_form.actions.place_order")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="plumberorder-success-popup">
          <div className="plumberorder-success-popup-content">
            <h2>
              {/* Order Successfully Placed! */}
              {t("plumberorderform.order_form.success_popup.title")}{" "}
              {/* CHANGED: Added translation */}
            </h2>
            <p>
              {/* Thank you for choosing HelpNao. */}
              {t("plumberorderform.order_form.success_popup.message1")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <p>
              {/* Your order is now pending confirmation. */}
              {t("plumberorderform.order_form.success_popup.message2")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <button
              className="plumberorder-btn plumberorder-btn-primary"
              onClick={closePopup}
            >
              {/* Ok */}
              {t("plumberorderform.order_form.success_popup.button")}{" "}
              {/* CHANGED: Added translation */}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="plumberorder-success-popup">
          <div className="plumberorder-success-popup-content">
            <h2>
              {/* Account Blocked */}
              {t("plumberorderform.order_form.blocked_popup.title")}{" "}
              {/* CHANGED: Added translation */}
            </h2>
            <p>
              {/* Your account is blocked due to excessive cancellations. */}
              {t("plumberorderform.order_form.blocked_popup.message1")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <p>
              {/* Please contact our support team for assistance. */}
              {t("plumberorderform.order_form.blocked_popup.message2")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <button
              className="plumberorder-btn plumberorder-btn-primary"
              onClick={closeBlockedPopup}
            >
              {/* Close */}
              {t("plumberorderform.order_form.blocked_popup.button")}{" "}
              {/* CHANGED: Added translation */}
            </button>
          </div>
        </div>
      )}
    </>
  );
  };

export default PlumberOrderForm;